import { render, staticRenderFns } from "./Fancafe.vue?vue&type=template&id=67c343ac"
import script from "./Fancafe.vue?vue&type=script&lang=js"
export * from "./Fancafe.vue?vue&type=script&lang=js"
import style0 from "./Fancafe.vue?vue&type=style&index=0&id=67c343ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports